var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{directives:[{name:"bg-typography",rawName:"v-bg-typography",value:('h1'),expression:"'h1'"}]},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"admin__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }